import React from 'react';
import { useIsUserOnline } from '@/hooks/use-presence';

interface OnlineIndicatorProps {
  userId: number;
}

export const OnlineIndicator: React.FC<OnlineIndicatorProps> = React.memo(({ userId }) => {
  const isOnline = useIsUserOnline(userId);

  if (!isOnline) return null;

  return (
    <div
      className="absolute h-2 w-2 rounded-full bg-green-500"
      style={{
        top: '-2px',
        right: '-2px',
        zIndex: 10
      }}
    />
  );
});

OnlineIndicator.displayName = 'OnlineIndicator';
